import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Input } from 'ctm-components';
import { regoLookupDefaultLicencePlateStateLabelSelector } from 'ctm-selectors/selectors/brand_content';
import { coverDetailVehicleRegoSelector } from 'ctm-selectors/selectors/form_payload';
import licencePlateLabels from './licence_plate_labels.json';
import styles from './registration_number.css';

/*
 * Render the Registration Number component
 * @param {Object} props - the incoming set of props
 * @param {String} state - the state of the users rego
 * @param {Object} inputProps - the props to pass to the input
 * @param {Boolean} isLoading - the boolean passed if the component is to display the loading style
 * @returns {Node} A component
 */
const RegistrationNumber = ({ state, inputProps, isLoading }) => {
    // eslint-disable-next-line no-shadow
    const rego = useSelector(coverDetailVehicleRegoSelector) ?? '';
    const defaultLicencePlateStateLabel = useSelector(regoLookupDefaultLicencePlateStateLabelSelector);
    const licencePlateClassName = isLoading ? styles.is_loading_text : styles[`text_${state}`];
    const licencePlateText = licencePlateLabels[state]
        ? licencePlateLabels[state].toUpperCase()
        : defaultLicencePlateStateLabel.toUpperCase();

    const className = isLoading ? styles.is_loading : styles[state];

    const regoInput = React.createRef();

    const focusInput = () => {
        if (inputProps) {
            // its an input
            // expection is being thrown when the user tries to click on the container
            regoInput.current.node.focus();
        }
    };

    return (
        <div className={`${className} data-hj-suppress`} onClick={focusInput} role="button" tabIndex={-1}>
            {inputProps ? <Input {...inputProps} ref={regoInput} className={styles[`input_${state}`]} /> : <span className={styles.rego_text}>{rego.toUpperCase()}</span>}
            <span className={licencePlateClassName}>{licencePlateText}</span>
        </div>
    );
};

RegistrationNumber.propTypes = {
    state: PropTypes.string,
    inputProps: PropTypes.object,
    isLoading: PropTypes.bool,
    mvlRego: PropTypes.string
};

export { RegistrationNumber };
